import { useState } from "react";
import {
  Button,
  Box,
  FormControl,
  FormLabel,
  Icon,
  Input,
  Stack,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { MdAdd } from "react-icons/md";
import { useQueryClient } from "react-query";

// Local imports
import { createTodo } from "../services/firebase";

const CreateTodoForm = ({ listId }) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const [title, setTitle] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const buttonSize = useBreakpointValue(["lg", "md"]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsDisable(true);
    await createTodo(listId, title);
    // refetch todos from server
    queryClient.invalidateQueries(["list-detail", listId]);
    toast({
      position: "top",
      title: "Successfully created new todo",
      isClosable: true,
      status: "success",
      duration: 3000,
    });
    setTitle("");
    setIsDisable(false);
  };

  return (
    <Box my={4}>
      <form onSubmit={handleSubmit}>
        <Stack
          direction={{ base: "column", sm: "row" }}
          align={{ base: "center", sm: "end" }}
        >
          <FormControl>
            <FormLabel hidden>Enter Todo</FormLabel>
            <Input
              type="text"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              isDisabled={isDisable}
              placeholder="Enter Todo ..."
            />
          </FormControl>
          <Button
            leftIcon={<Icon as={MdAdd} />}
            type="submit"
            size={buttonSize}
            colorScheme="teal"
            variant="outline"
            mt={3}
            isDisabled={isDisable}
          >
            Todo
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default CreateTodoForm;
